// Decryption with enhanced security
export const decryptData = async (encryptedData, key) => {
    // Input validation
    if (!encryptedData || typeof encryptedData !== 'object') {
        throw new Error('Invalid input: encryptedData must be an object')
    }
    
    if (!encryptedData.ciphertext || !encryptedData.iv) {
        throw new Error('Invalid input: encryptedData must contain ciphertext and iv')
    }
    
    if (!(encryptedData.ciphertext instanceof Uint8Array)) {
        throw new Error('Invalid input: ciphertext must be a Uint8Array')
    }
    
    if (!(encryptedData.iv instanceof Uint8Array)) {
        throw new Error('Invalid input: iv must be a Uint8Array')
    }
    
    if (!key || !(key instanceof CryptoKey)) {
        throw new Error('Invalid input: key must be a valid CryptoKey')
    }
    
    // Check key usage
    if (!key.usages.includes('decrypt')) {
        throw new Error('Invalid key: key must support decryption')
    }
    
    // Validate IV length (12 bytes for AES-GCM)
    if (encryptedData.iv.length !== 12) {
        throw new Error('Invalid IV length: must be 12 bytes for AES-GCM')
    }
    
    // Additional size check
    if (encryptedData.ciphertext.length > 1024 * 1024) { // 1MB limit
        throw new Error('Ciphertext too large: maximum 1MB allowed')
    }

    try {
        const decryptedData = await crypto.subtle.decrypt(
            {
                name: "AES-GCM",
                iv: encryptedData.iv,
                tagLength: encryptedData.tagLength || 128
            },
            key,
            encryptedData.ciphertext
        )

        // Decode the decrypted data
        const decoder = new TextDecoder()
        const decryptedText = decoder.decode(decryptedData)
        
        // Clear sensitive data (convert to Uint8Array first)
        const decryptedArray = new Uint8Array(decryptedData)
        decryptedArray.fill(0)
        
        return decryptedText
    } catch (error) {
        throw new Error(`decryptData() failed: ${error.message}`)
    }
}

export default decryptData